import Entity from "./entity";

export enum AdminSidebarStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

// One row per sidebar item; both groups and leaf links live in the same
// table. `parent` is another row's `_id`, `null` for top-level entries.
// `roleIds` is the set of Role document ids allowed to see this item.
export interface AdminSidebar extends Entity {
  name: string;
  label: string;
  icon: string;
  url: string;
  parent: string | null;
  order: number;
  status: AdminSidebarStatus;
  roleIds: string[];
}

// Convenience tree shape the page builds client-side from the flat list.
export interface AdminSidebarNode extends AdminSidebar {
  children: AdminSidebarNode[];
}
